
export default {
  props: {
    actionCloseCart: {
      type: Function,
      default: () => {},
    },
  },
}
